// extracted by mini-css-extract-plugin
export default {"container":"uo-z","brandName":"vo-z","productName":"wo-z","productNamePdpEnhancements":"xo-z","breakLongProductName":"yo-z"};